module.exports = __webpack_public_path__ + "media/components/country-flag/static/nz-55c65e06d0b73b57f438e2af94f730ff.svg";